import React, { useState, useEffect } from "react";
import Navbar from "./Nav";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import "./App.css";
import Aos from "aos";
import "aos/dist/aos.css";
import p1 from "./images/ecom.png";
import p from "./images/tm.png";
import p2 from "./images/merncrud.png";
import p3 from "./images/tetflix.png";
import p5 from "./images/PAi.png";
import p6 from "./images/frontend.png";
import p7 from "./images/frontend2.png";
import jp from "./images/jobportal website.png";
import loan from "./images/loan.png";
import book from "./images/bookhaven.png";
import lotus from "./images/lotus web app.png";

const Project = () => {
  /*  const projects = [
    {
      id: 1,
      name: "Ecommerce FullStack Project",
      image: p1,
      description: "A premium tea e-commerce platform offering a wide range of organic teas.",
    },
    {
      id: 2,
      name: "SupLink",
      image: p2,
      description: "A dynamic platform for managing professional and personal links effectively.",
    },
    {
      id: 3,
      name: "Pulse",
      image: p4,
      description: "A real-time analytics dashboard to track website and app metrics seamlessly.",
    },
    {
      id: 4,
      name: "Tetflix",
      image: p3,
      description: "A feature-rich movie streaming platform with personalized recommendations.",
    },
    {
      id: 5,
      name: "Potential AI",
      image: p5,
      description: "An AI-powered platform for generating creative and efficient solutions.",
    },
  ]; */

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <div className="overflow-x-hidden text-white background elegant font-bold">
      <Navbar />
      <div className="w-full container px-5 block lg:flex py-24 mx-auto justify-between">
        <div className="w-full my-10 lg:my-0 lg:w-full mx-auto">
          <div className="md:bg-zinc-900 rounded-xl container px-5 py-10">
            <p className="text-base">
              <span className="text-lime-500 md:text-5xl text-3xl Riesling font-bold">
                Featured Projects!
              </span>
              <br />
              <br />
              Below is a list of some of my recently created jobs with detailed
              information on those jobs. Each project has a live link attached
              and what technology the project has been developed using. Projects
              are usually bound by web design and development information.
              <br />
            </p>
            <div className="container mx-auto px-7 my-24">
              <div
                className="grid grid-cols-1 lg:grid-cols-2 gap-y-28 gap-x-6"
                id="products"
              >
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={loan}
                      alt=""
                      className="w-fit h-72 object-cover object-center  mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Loan Management Tracking System
                    </h2>

                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://loan-tracking-system.netlify.app/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/loan-tracking-system-client">
                        Client
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/loan-tracking-system-server">
                        Server
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={jp}
                      alt=""
                      className="w-fit h-72 object-cover object-center  mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Job Portal
                    </h2>

                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://job-portal0001.netlify.app">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/jobportal">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={book}
                      alt=""
                      className="w-fit h-72 object-cover object-center  mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      The Book Haven
                    </h2>

                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://the-book-haven-universe.netlify.app/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/The-Book-Haven-client">
                        Client
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/The-Book-Haven-server">
                        Server
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p}
                      alt=""
                      className="w-fit h-72 object-cover object-center  mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Task Management Web App
                    </h2>

                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://taskmanagement-kdq0.onrender.com">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/TaskManagement">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={lotus}
                      alt=""
                      className="w-fit h-72 object-cover object-center  mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Lotus Web-App
                    </h2>

                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://lotus-game-web-app.firebaseapp.com">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/lotus-web-app">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div>

                {/* <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p1}
                      alt=""
                      className="w-fit h-72 object-cover object-center hover:opacity-30 transition-opacity mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Ecommerce FullStack Project
                    </h2>
                    <p className="text-lg lg:text-xs">
                      A premium e-commerce platform offering a wide range of
                      organic teas.
                    </p>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://ecommerce-mern-bntv.onrender.com/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/Ecommerce-MERN">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div> */}
                {/* <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p2}
                      alt=""
                      className="w-fit h-72 object-cover object-center hover:opacity-30 transition-opacity mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Simple Crud Operation
                    </h2>
                    <p className="text-lg lg:text-xs">
                      This project is a simple MERN stack CRUD dashboard where
                      anyone can update or delete items.It features a React
                      frontend, an Express.js backend, and MongoDB for data
                      storage.
                    </p>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://merncrud-kjyp.onrender.com/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500">
                      <a href="https://github.com/tayyab011/MernCrud">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div> */}
                {/*  <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p3}
                      alt=""
                      className="w-fit h-72 object-cover object-center hover:opacity-30 transition-opacity mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Tetflix
                    </h2>
                    <p className="text-lg lg:text-xs">
                      A feature-rich movie streaming platform with personalized
                      recommendations.This projects main goal is Frontend Part
                      and attractive design.
                    </p>
                    <button className="text-base  hover:text-lime-500 hover:font-extrabold ">
                      <a href="https://tetflix.netlify.app">Live Link</a>
                    </button>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://github.com/tayyab011/Tetflix-project">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p5}
                      alt=""
                      className="w-fit h-72 object-cover object-center hover:opacity-30 transition-opacity mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Potential AI
                    </h2>
                    <p className="text-lg lg:text-xs">
                      An AI-powered platform for generating creative and
                      efficient solutions.This projects main goal is Frontend
                      Part and attractive design.
                    </p>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold ">
                      <a href="https://potentialaiproject.netlify.app/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://github.com/tayyab011/Potential-Ai-Project">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p6}
                      alt=""
                      className="w-fit h-72 object-cover object-center hover:opacity-30 transition-opacity mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Uchiha
                    </h2>
                    <p className="text-lg lg:text-xs">
                      This is just a Frontend Basic Project with aos Animation
                    </p>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold ">
                      <a href="https://project1tayyab.netlify.app/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://github.com/tayyab011/Project-4">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div>
                <div
                  className="card lg:card-side bg-zinc-950 shadow-xl"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <figure className="lg:w-1/2 w-full mx-auto pl-4">
                    <img
                      src={p7}
                      alt=""
                      className="w-fit h-72 object-cover object-center hover:opacity-30 transition-opacity mx-auto rounded-3xl"
                    />
                  </figure>
                  <div className="w-full lg:w-1/2 card-body">
                    <h2 className="card-title carltine font-extrabold text-4xl lg:text-3xl lg:text-left text-center text-lime-500">
                      Int. Decore
                    </h2>
                    <p className="text-lg lg:text-xs">
                      This is just a Frontend Basic Project with aos Animation
                    </p>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold ">
                      <a href="https://project2tayyab.netlify.app/">
                        Live Link
                      </a>
                    </button>
                    <button className="text-base hover:text-lime-500 hover:font-extrabold">
                      <a href="https://github.com/tayyab011/Project-4">
                        Github Link
                      </a>
                    </button>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:flex rounded-xl px-5 container justify-center mx-auto py-24">
        <div className="lg:w-1/2 w-full bg-gradient-to-r from-gray-500 to-lime-800 py-8 rounded-xl lg:mr-3 container mx-auto">
          <p className="text-sm px-5 text-zinc-300">
            <span className="text-zinc-300 md:text-5xl text-3xl Riesling font-bold">
              Experience
            </span>{" "}
            <br />
            <br />
            <br />
            - Experience in Mern Stack Development
            <br />
            <br />
            - Experience with Upwork and FIVERR. <br />
            <br />- Experience with ReactJS, JavaScript, NodeJS, ExpressJS,
            MongoDB, Git & GitHub for version controll ,Zustand and React-Redux
            For State Management
          </p>
        </div>
        <div className="py-5 rounded-xl lg:ml-2 my-10 lg:my-0 mx-auto container lg:w-1/2 w-full bg-gradient-to-r from-gray-500 to-lime-800 text-zinc-300 text-right px-4">
          <span className="text-zinc-300 md:text-5xl text-3xl Riesling font-bold">
            Education
          </span>{" "}
          <br />
          <br />
          <code>2022 - Present</code> <br />
          Learnings on Web Application Development <br />
          Programming Hero
          <br />
          <br />
          <code>2023 - Current</code> <br />
          Bachelor of Computer Science (BSC) <br />
          Institute of Science and Technology, Bangladesh
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Project;
